import { LogLevel } from 'fitforce-logging';

export const environment = {
  production: true,
  api_url: 'https://api.usmcfitforce.com/',
  version: '1.1.0 (e23e5586)',
  applySubstitutions: applySubstitutions,
  create_account_url: 'https://account.usmcfitforce.com/',
  reset_password_url: 'https://account.usmcfitforce.com/forgot/',
  request_account_url: 'https://account.usmcfitforce.com/request',
  logLevel: LogLevel.DEBUG,
  checkUpdateInterval: 60 * 60 * 1000,
  externalSupportService: 'https://usmcfitforce.com/',
  externalSupportUrl: 'mailto:fitforce@aptima.com',
  exerciseLibraryEditorPermissionUUID: '19c0af5d-eb1d-47be-8ebb-9d1d218d6723',
  userManagementPermissionUUID: 'da64dc42-079f-4a34-b038-932eb23c9143',
  rolePermManagementPermissionUUID: 'b074d268-ef3c-4612-abe5-978ffa1e1fe0',
  plannerAccessPermissionUuid: '8d5834f2-9656-431d-9e82-6f8067adea2e',
  mobileUrl: 'https://mobile.usmcfitforce.com/',
  hideConsent: 'false',
  minPasswordLength: '15',
};

export function applySubstitutions(url) {
  const myUrl = url.replace(/{{HOSTNAME}}/gi, location.hostname);
  return myUrl;
}
